/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { postSearchAggregate } from "../../funcs/postSearchAggregate.js";
import { PostSearchAggregateRequest$zodSchema } from "../../models/postsearchaggregateop.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: PostSearchAggregateRequest$zodSchema,
};

export const tool$postSearchAggregate: ToolDefinition<typeof args> = {
  name: "search-post-search-aggregate",
  description: `智能搜索

想在你的应用中集成搜索功能？我们提供了一个强大的搜索引擎API，让你可以轻松实现实时网页搜索。

## 功能概述

UAPI Pro Search 是一个智能搜索引擎，采用机器学习算法对搜索结果进行智能排序，确保最相关的内容排在前面。你可以用它搜索任何关键词，也可以限定在特定网站或特定文件类型中搜索。

- **实时网页搜索**: 毫秒级响应，快速返回搜索结果
- **智能排序**: 采用机器学习回归排序算法，结果更精准
- **时间排序**: 支持按发布时间排序，获取最新内容
- **时间范围过滤**: 支持按天/周/月/年过滤结果
- **站内搜索**: 支持 \`site:\` 操作符，在指定网站内搜索
- **文件类型过滤**: 支持 \`filetype:\` 操作符，快速找到 PDF、Word 等特定格式文件

> [!VIP]
> 本API目前处于**限时免费**阶段，我们鼓励开发者集成和测试。未来，它将转为付费API，为用户提供更稳定和强大的服务。
      `,
  scopes: ["read"],
  annotations: {
    "title": "",
    "destructiveHint": false,
    "idempotentHint": false,
    "openWorldHint": true,
    "readOnlyHint": true,
  },
  args,
  tool: async (client, args, ctx) => {
    const [result] = await postSearchAggregate(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    return formatResult(result.value);
  },
};
